window.$ = window.jQuery = require('jquery')

import 'bootstrap-sass'

// Import webfonts
import 'typeface-lato'
import 'typeface-caveat'

// Import lazysizes
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset'

// Import and initialize medium-zoom
import mediumZoom from 'medium-zoom'
mediumZoom('[data-action="zoom"]')

// https://www.npmjs.com/package/slick-carousel
import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'

// https://www.npmjs.com/package/@chenfengyuan/datepicker
import '@chenfengyuan/datepicker/dist/datepicker.css'
import '@chenfengyuan/datepicker/dist/datepicker'
import '@chenfengyuan/datepicker/i18n/datepicker.de-DE'

// Import JS files from SitePackage
import './Component/InitializeBootstrapComponents'
import './Component/Menu'
import './Component/MobileMenu'
import './Component/SmoothScroll'
import './Component/Carousel'
import './Component/CarouselKnownFrom'
import './Component/CarouselService'
import './Component/FontAwesome'
import './Component/FormConsulting'
import './Component/FormValidation'

import '../Fusion/Component/Atom/Modal/Modal'



// WEBPACK FOOTER //
// ./Private/JavaScript/App.js